/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_How_Triggers_ValueInputs */



/**
* | output |
* | --- |
* | "You set up a schedule next, right after creating" |
*
* @param {Agent_Wizard_How_Triggers_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_how_triggers_value = /** @type {((inputs?: Agent_Wizard_How_Triggers_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_How_Triggers_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie richten als Nächstes einen Zeitplan ein, direkt nach dem Erstellen")
	return /** @type {LocalizedString} */ ("You set up a schedule next, right after creating")
});